"use client"
import PlayButton from "@/components/ui/play-button"
import * as Dialog from "@radix-ui/react-dialog"
import { PropsWithChildren } from "react"
import { IoClose } from "react-icons/io5"

const VideoModal = ({
  children,
  thumb,
  youtubeId,
}: PropsWithChildren<{ thumb: string; youtubeId: string }>) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <div className="relative w-full h-full aspect-video">
          <div className="flex absolute top-0 justify-center items-center w-full h-full">
            <video src={thumb} className="object-cover w-full h-full" loop muted autoPlay />
          </div>
          <div className="flex absolute top-0 justify-center items-center w-full h-full">
            <PlayButton>{children}</PlayButton>
          </div>
        </div>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black opacity-70 data-[state=open]:animate-overlayShow" />
        <Dialog.Content className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="flex flex-col gap-2 w-full max-w-4xl">
            <div className="flex justify-end items-center">
              <Dialog.Close asChild>
                <button
                  className="
                  cursor-pointer appearance-none items-center justify-center rounded-lg bg-white aspect-square text-forest
                  enabled:hover:bg-[#DEE3DF] enabled:active:bg-[#C5CEC7]
                  "
                  aria-label="Close"
                >
                  <IoClose size={33} />
                </button>
              </Dialog.Close>
            </div>

            <iframe
              width="100%"
              src={`https://www.youtube.com/embed/${youtubeId}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="rounded-sm aspect-video"
            ></iframe>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default VideoModal
